import React, { CSSProperties, DetailedHTMLProps, forwardRef, HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';

import { GAP_UNIT_SIZE } from '../../constants';

import styles from './Flex.module.scss';

export interface IFlexProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
    align?: 'start' | 'center' | 'end' | 'stretch' | 'baseline';
    justify?: 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly';
    flex?: CSSProperties['flex'];
    wrap?: boolean;
    gap?: number;
    children?: ReactNode[] | ReactNode;
}

export const Flex = forwardRef<HTMLDivElement, IFlexProps>(
    ({ align, children, direction, gap, justify, wrap, className, style, flex, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={classNames(
                    styles.flex,
                    styles[`align-${align}`],
                    styles[`direction-${direction}`],
                    styles[`justify-${justify}`],
                    { [styles.wrap]: wrap },
                    className,
                )}
                style={{ gap: gap ? `${gap * GAP_UNIT_SIZE}px` : undefined, flex, ...style }}
                {...props}
            >
                {children}
            </div>
        );
    },
);

Flex.displayName = 'Flex';
